import PropTypes from 'prop-types';

export default PropTypes.shape({
  load: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
  options: PropTypes.object,
});
